var React = require('react');

function BevelledCornersInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M738 397.848V97.0615C685.098 97.0615 642.343 53.5632 642.343 0H95.6574C95.6574 53.6789 52.7883 97.0615 0 97.0615V397.848C55.6386 397.848 100.674 443.545 100.674 500H637.44C637.44 443.66 682.475 397.848 738 397.848Z"}));
}

BevelledCornersInline.defaultProps = {"width":"738","height":"500","viewBox":"0 0 738 500","fill":"none"};

module.exports = BevelledCornersInline;

BevelledCornersInline.default = BevelledCornersInline;
